module.exports = __webpack_public_path__ + "static/media/utilities.d5151d91.png";